"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceedsPreauthIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const ExceedsPreauthIcon = ({ className = '', }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("span", { className: `inline-flex items-center justify-center text-amber-600 ${className}`, "aria-label": t('exceedsPreauth.tooltipTitle'), role: "img", children: (0, jsx_runtime_1.jsx)("i", { className: "pi pi-exclamation-triangle text-sm", "aria-hidden": "true" }) }));
};
exports.ExceedsPreauthIcon = ExceedsPreauthIcon;
